import React from "react";
import { useTranslation } from "react-i18next";
import { Grid, Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";

import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";

import ConfirmationModal from "../../../../../components/Dialogs/ConfirmationModal";

import { Color } from "../../../../../components/Form/Button";

import BadgeTaskType from "../../../../../components/Generic/BadgeTaskType";

import { Task } from "../../../../../models/task";
import { Job } from "../../../../../models/job";

import styles, { GridHeaderTable } from "./styles";

type Props = {
  open?: boolean;
  onClose?: () => void;
  tasksInProgress?: Task[];
  orderDelete?: Job;
};

const TasksInProgressModal = (props: Props) => {
  const { open, onClose, tasksInProgress, orderDelete } = props;
  const { t: translate } = useTranslation();

  const renderTasks = () => {
    if (tasksInProgress && tasksInProgress?.length > 0) {
      return tasksInProgress?.map((task) => {
        return (
          <Grid
            key={task?.id}
            item
            alignItems="center"
            direction="row"
            container
            justifyContent="center"
          >
            <Grid item xs={3}>
              <BadgeTaskType
                sxBadge={styles.badgeTaskType}
                sxText={styles.badgeText}
                value={task?.type}
              />
            </Grid>
            <Grid item xs={3}>
              <Typography
                fontFamily="Inter"
                fontSize="14px"
                fontWeight={500}
                lineHeight="24px"
                color="#465869"
              >
                {orderDelete?.reference || ""}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                fontFamily="Inter"
                fontSize="14px"
                fontWeight={500}
                lineHeight="24px"
                color="#465869"
              >
                {orderDelete?.customer?.name || ""}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                fontFamily="Inter"
                fontSize="14px"
                fontWeight={500}
                lineHeight="24px"
                color="#465869"
              >
                {task?.startDate
                  ? format(
                      utcToZonedTime(
                        task?.startDate,
                        Intl.DateTimeFormat().resolvedOptions().timeZone
                      ),
                      "dd/MM/yyyy hh:mm aa"
                    )
                  : ""}
              </Typography>
            </Grid>
          </Grid>
        );
      });
    }
    return null;
  };

  return (
    <ConfirmationModal
      open={open || false}
      type="warning"
      title={translate("oops")}
      leftIconTitle={<WarningAmberOutlinedIcon htmlColor="#F79009" />}
      closeModal={onClose}
      customColorSave={Color.WARNING}
      textSubmit={translate("ok")}
      showCancelButton={false}
      submit={onClose}
    >
      <Stack direction="column" width="100%" marginTop="16px" spacing={2}>
        <Typography
          fontFamily="Inter"
          fontSize="16px"
          fontWeight={400}
          lineHeight="24px"
          color="#232325"
          marginLeft="2px"
        >
          {translate("itLooksLikeSomeTasksOfThisOrderAreInProgress")}
        </Typography>
        <Stack>
          <GridHeaderTable container alignItems="center" justifyContent="center">
            <Grid item xs={3}>
              <Typography
                fontFamily="Manrope"
                fontSize="12px"
                fontWeight={700}
                lineHeight="26px"
                color="#308CDB"
              >
                {translate("task")}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                fontFamily="Manrope"
                fontSize="12px"
                fontWeight={700}
                lineHeight="26px"
                color="#308CDB"
              >
                {translate("reference")}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                fontFamily="Manrope"
                fontSize="12px"
                fontWeight={700}
                lineHeight="26px"
                color="#308CDB"
              >
                {translate("receiver")}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                fontFamily="Manrope"
                fontSize="12px"
                fontWeight={700}
                lineHeight="26px"
                color="#308CDB"
              >
                {translate("date")}
              </Typography>
            </Grid>
          </GridHeaderTable>
          <Grid
            direction="column"
            container
            alignItems="center"
            justifyContent="center"
            paddingX="16px"
            paddingTop="8px"
            spacing={1}
          >
            {renderTasks()}
          </Grid>
        </Stack>
        <Typography
          fontFamily="Inter"
          fontSize="16px"
          fontWeight={400}
          lineHeight="24px"
          fontStyle="italic"
          color="#F79009"
        >
          {translate("youShouldCancelTheseTasksInYourAppBeforeContinue")}
        </Typography>
      </Stack>
    </ConfirmationModal>
  );
};

export default TasksInProgressModal;
